import React from "react";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";
import { useStaticQuery, graphql, PageProps } from "gatsby";
import { useGlobalState } from './global-context';

interface ImageAsset {
  _id?: string;
  gatsbyImageData?: IGatsbyImageData;
}

interface ImageNode {
  asset?: {
    _id?: string;
  };
  alt?: string;
}

interface ImageGProps {
  node?: ImageNode;
  nodeM?: ImageNode;
  alt?: string;
}

const ImageG: React.FC<ImageGProps> = ({ node, nodeM, alt }) => {
  if (!node || !node.asset) {
    return null;
  }

  const { isMobile } = useGlobalState();
  const altVal = alt || node.alt || "";

  // Query for all Sanity images using gatsbyImageData
  const data = useStaticQuery(graphql`
    query {
      allSanityImageAsset {
        nodes {
          _id
          gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP], layout: FULL_WIDTH)
        }
      }
    }
  `);

  // Helper function to get image data from node
  const getImageData = (imageNode?: ImageNode): IGatsbyImageData | undefined => {
    const imageId = imageNode?.asset?._id;
    return data.allSanityImageAsset.nodes.find((n: ImageAsset) => n._id === imageId)?.gatsbyImageData;
  };

  // Get gatsbyImageData for node and nodeM
  const imageData = getImageData(node);
  const imageMData = (nodeM && nodeM.asset) ? getImageData(nodeM) : undefined;

  return (
    <>
      {isMobile && imageMData ? (
        <GatsbyImage image={getImage(imageMData)!} alt={altVal} />
      ) : (
        <GatsbyImage image={getImage(imageData)!} alt={altVal} />
      )}
    </>
  );
};

export default ImageG;
